import { formatPrice } from "./teamCurrencyFormatting";

const settingText = (value) => {
  if (value === "true") return "On";
  if (value === "false") return "Off";
  let parsed;
  try {
    parsed = JSON.parse(value);
  } catch {
    return value;
  }
  const items = Array.isArray(parsed) ? parsed : [parsed];
  const text = items
    .filter((item) => item !== null && item !== "")
    .map((item) => (typeof item === "object" ? Object.values(item).filter(Boolean).join(" ") : String(item)))
    .join(", ");
  return text || "None";
};

// A series date as the update and reset modals name it: "Sun, Nov 22".
export const formatDateLong = (iso, timeZone) =>
  new Date(iso).toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    ...(timeZone ? { timeZone } : {}),
  });

export const formatDateTimeLong = (iso, timeZone) => {
  const time = new Date(iso).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", ...(timeZone ? { timeZone } : {}) });
  return `${formatDateLong(iso, timeZone)} · ${time}`;
};

// An own value's name, even one the server sends without a label.
export const ownLabel = (own) => own.label || own.key;

// Each own value's name once: a setting with several keys names one row.
export const ownLabels = (ownValues) => [...new Set((ownValues || []).map(ownLabel))];

export const groupOwnValues = (ownValues) => Object.values((ownValues || []).reduce((byGroup, value) => {
  const label = ownLabel(value);
  const group = value.key.startsWith("set:") ? `set:${label}` : value.key;
  (byGroup[group] = byGroup[group] || { label, values: [] }).values.push(value);
  return byGroup;
}, {}));

export const joinOwnValues = (values, side, formatting) => {
  const texts = values.map((value) => formatOwnValue(value[side], side === "series" && value.kind === "removed" ? "text" : value.kind, formatting));
  const set = values.length > 1 ? texts.filter((text) => text !== "None") : texts;
  return set.length > 0 ? set.join(", ") : "None";
};

export const formatOwnValue = (value, kind, { currency, timeZone } = {}) => {
  if (kind === "removed") return "Removed";
  // A row the series dropped that this date still has.
  if (kind === "extra_row" && (value === null || value === undefined || value === "")) return "Removed from series";
  if (value === null || value === undefined || value === "") return kind === "quantity" ? "Unlimited" : "None";

  switch (kind) {
    case "money":
      return formatPrice(value, currency).replace(/\.00$/, "");
    case "quantity":
      return String(Math.round(Number(value)));
    case "percentage":
      return `${Number(value)}%`;
    case "time":
      return new Date(value).toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        ...(timeZone ? { timeZone } : {}),
      });
    case "setting":
      return settingText(value);
    default:
      // A kind added on the server before this file knows it.
      return typeof value === "object" ? settingText(JSON.stringify(value)) : String(value);
  }
};
